import React from 'react';
import "./DashServices.css"
import Services from "../../../components/accordion/Services";

function DasboardServices({userRole = "USER"}) {
    return (
        <div className="service-head-template-dash">
            <div className="service-inner-component-dash">
                <Services userRole={userRole} />
            </div>
        </div>
    );
}

export default DasboardServices;

